import { Spacing, Text } from "@ottatech/design";

import { Company } from "schema";
import { Profile } from "components/Profile";
import { Separator } from "components/Separator";

interface PeopleAtCompanyProps {
  company: Pick<Company, "founders" | "peopleProgressing">;
}

export function PeopleAtCompany({
  company: { founders, peopleProgressing },
}: PeopleAtCompanyProps): React.ReactElement | null {
  if (founders.length + peopleProgressing.length === 0) {
    return null;
  }

  return (
    <>
      <Spacing>
        {founders.length > 0 && (
          <div data-testid="founders">
            <Spacing>
              <Text bold size={1}>
                Founders
              </Text>
              <Spacing>
                {founders.map(
                  ({ id, name, title: personTitle, linkedinUrl, bio }) => (
                    <Profile
                      key={id}
                      name={name}
                      title={personTitle}
                      linkedIn={linkedinUrl}
                      bio={bio}
                    />
                  )
                )}
              </Spacing>
            </Spacing>
          </div>
        )}
        {peopleProgressing.length > 0 && (
          <div data-testid="people-progressing">
            <Separator />
            <Spacing>
              <Text bold as="h3" size={1}>
                People progressing
              </Text>
              {peopleProgressing.map(({ id, name, linkedinUrl, bio }) => (
                <Profile
                  key={id}
                  name={name}
                  linkedIn={linkedinUrl}
                  bio={bio}
                />
              ))}
            </Spacing>
          </div>
        )}
      </Spacing>
    </>
  );
}
